import { render } from "./AsBanner.vue?vue&type=template&id=61608c5f&ts=true"
import script from "./AsBanner.vue?vue&type=script&lang=ts"
export * from "./AsBanner.vue?vue&type=script&lang=ts"

import "./AsBanner.vue?vue&type=style&index=0&id=61608c5f&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__